import { AppointmentAlerts as BaseAppointmentWarnings } from '../PatientAppointmentMeta/AppointmentAlerts'
import {
  usePatientApptMeta,
  type PatientAppointmentMetaArg,
} from '../PatientAppointmentMeta/hooks'
export const AppointmentWarnings = (props: PatientAppointmentMetaArg) => {
  const args = usePatientApptMeta(props)
  return <BaseAppointmentWarnings {...args} />
}
